import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { ProcessEventService } from '@shared/services/process-event.service';
import { TrackerService } from '@shared/services/tracker.service';
import { PopinComponent } from '../popin/popin.component';
import { CancelPopinVM } from './cancel-popin.viewmodel';

@Component({
  selector: 'app-cancel-open-banking-popin',
  templateUrl: './cancel-open-banking-popin.component.html',
  standalone: true,
  imports: [PopinComponent, TranslateModule],
})
export class CancelOpenBankingPopinComponent implements OnChanges {
  @Input() show = false;
  @Output() continue = new EventEmitter<void>();
  private cancelPopinVM: CancelPopinVM;

  constructor(
    private processEventService: ProcessEventService,
    private tracker: TrackerService
  ) {
    this.cancelPopinVM = new CancelPopinVM(this.processEventService, this.tracker);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes?.show?.previousValue === false && changes.show.currentValue === true) {
      this.tracker.trackPage({ taggingPage: 'ABANDON_BANK_CONNECTION' });
    }
  }

  continueProcess() {
    this.cancelPopinVM.continueProcess(this.continue);
  }

  rejected() {
    this.show = false;
    this.cancelPopinVM.rejected();
  }
}
